import { put, takeLatest, all, select } from 'redux-saga/effects';
import { API_URL } from 'containers/App/constants';
import { offersLoaded, setLoading } from './actions';
import { updatePaginator, setPage } from 'components/Paginator/actions';
import { resetData } from 'components/PrescoringTool/actions';
import { getRequestHeadersAsLogged, responseHandler } from '../../utils/auth';

import { makeSelectSelectedParams } from 'components/Search/selectors';
import { makeSelectSustainabilitySelected, makeSelectCheckInputData, makeSelectCheckResponse } from 'components/PrescoringTool/selectors';

import {
  makeSelectCurrentPage,
  makeSelectItemsPerPage,
} from 'components/Paginator/selectors';

import {
  makeSelectSelectedSort,
  makeSelectSelectedTags,
} from 'components/HorizontalFilter/selectors';

/* Action watchers */
import { GET_OFFERS } from './constants';
import {
  REMOVE_ALL,
  ADD_OPTION,
  REMOVE_OPTION,
  UPDATE_SORT,
} from 'components/HorizontalFilter/constants';
import { UPDATE_PARAMS, REMOVE_PARAM } from 'components/Search/constants';
import { SET_PAGE_NUMBER } from 'components/Paginator/constants';
import { SET_SUSTAINABILITY_SELECTED } from 'components/PrescoringTool/constants';

function* fetchOffers(action) {
  const { type } = action;
  // Handle loading
  yield put(setLoading(true));

  if ([UPDATE_PARAMS, REMOVE_PARAM, REMOVE_OPTION, SET_SUSTAINABILITY_SELECTED].indexOf(type) >= 0) {
    if (
      (action.value && ['piva', 'privati'].indexOf(action.value) >= 0) ||
      (action.paramName && ['monthly_rate', 'deposit'].indexOf(action.paramName) >= 0) ||
      (action.param && ['monthly_rate', 'deposit'].indexOf(action.param.name) >= 0)
      ) {
      yield put(resetData());
    }

    yield put(setPage(1));
  }

  if ([REMOVE_ALL].indexOf(type) >= 0) {
    yield put(resetData());
    yield put(setPage(1));
  }

  const params = yield select(makeSelectSelectedParams());
  const sustainability = yield select(makeSelectSustainabilitySelected());
  let prescoringResponse = yield select(makeSelectCheckResponse());
  let inputData = yield select(makeSelectCheckInputData());
  prescoringResponse = prescoringResponse.hasOwnProperty('_root') ? prescoringResponse.toJS() : prescoringResponse;
  inputData = inputData.hasOwnProperty('_root') ? inputData.toJS() : inputData;

  const requestParams = [];
  params.map(param => (requestParams[param.name] = param.value));

  requestParams['answers'] = inputData.answers || {};
  requestParams['contractualCategory'] = inputData.contractualCategory;

  if (sustainability) {
    requestParams['sustainability'] = sustainability || [];
  }

  const tags = yield select(makeSelectSelectedTags());
  const requestTags = [];
  tags.map(tag => requestTags.push(tag.value));

  const requestSort = yield select(makeSelectSelectedSort());

  const page = yield select(makeSelectCurrentPage());
  const items = yield select(makeSelectItemsPerPage());

  const requestURL = `${API_URL}search/offers`;
  const requestBody = {
    ...requestParams,
    ...prescoringResponse || {},
    sort: requestSort,
    tags: requestTags,
    page,
    items,
  };

  try {
    const parameters = {
      method: 'POST',
      headers: getRequestHeadersAsLogged(),
      body: JSON.stringify(requestBody),
    };
    const request = yield fetch(requestURL, parameters).then(response =>
      responseHandler(response)
    );

    yield all([
      put(offersLoaded(request.items.data, request.total)),
      put(
        updatePaginator(request.total, request.lastPage, request.currentPage),
      ),
    ]);
  } catch (err) {
    console.log('request error', err);
  }
}

function* actionWatcher() {
  yield takeLatest(
    [
      SET_PAGE_NUMBER,
      UPDATE_PARAMS,
      REMOVE_PARAM,
      REMOVE_ALL,
      REMOVE_OPTION,
      UPDATE_SORT,
      ADD_OPTION,
      GET_OFFERS,
      SET_SUSTAINABILITY_SELECTED,
    ],
    fetchOffers,
  );
}

export default function* offersData() {
  yield all([actionWatcher()]);
}
